<!-- //Formulario TIPO PF -->
<div *ngIf="typeForm == 'PF'" class="col-11 col-lg-10 col-sm-12 col-md-12 box-form p-5  mt-3">
  <div class="row">
    <span data-testid="botao-voltar" class="back-button" (click)="backStep()">
      <i class="fas fa-angle-left"></i> voltar
    </span>
  </div>
  <mdb-stepper [linear]="true" #stepperPF class="col-12">
    <mdb-step name="Dados do Investidor" [stepForm]="formInvestidorPF">
      <app-etapa-cadastro-email
        etapa="dados"
        [typeForm]="typeForm"
        [formInvestidorPF]="formInvestidorPF"
        [formInvestidorPJ]="formInvestidorPJ"
        [tableDdi]="tableDdi"
        [showPassword]="showPassword"
        [maiorDeIdade]="maiorDeIdade"
        [nextDisabled]="nextDisabled"
        (showPasswordChange)="showPassword = $event"
        (proximo)="nextStep()">
      </app-etapa-cadastro-email>
    </mdb-step>

    <mdb-step name="Validar Email" [editable]="true" [stepForm]="formToken">
      <app-etapa-cadastro-email
        etapa="email"
        [typeForm]="typeForm"
        [formToken]="formToken"
        [disableButton]="disableButton"
        (voltarToken)="resetStep()"
        (continuarToken)="nextStepEmail()"
        (reenviarToken)="resendToken()">
      </app-etapa-cadastro-email>
    </mdb-step>
  </mdb-stepper>
</div>

<!-- //Formulario TIPO PJ -->
<div *ngIf="typeForm == 'PJ' || typeForm == 'FUNDO_INVESTIMENTO'" class="col-lg-10 col-sm-12 col-md-12 box-form p-5  mt-3">
  <!-- Formulário Pessoa Juridica (((REFATORAR -> COMPONENTE))) -->
  <div class="row">
    <span data-testid="botao-voltar" class="back-button" (click)="backStep()">
      <i class="fas fa-angle-left"></i> voltar
    </span>
  </div>
  <mdb-stepper [linear]="true" [contentEditable]="false" #stepper class="col-12">
    <mdb-step name="Dados do Solicitante" [editable]="true" [stepForm]="formInvestidorPJ">
      <app-etapa-cadastro-email
        etapa="dados"
        [typeForm]="typeForm"
        [formInvestidorPF]="formInvestidorPF"
        [formInvestidorPJ]="formInvestidorPJ"
        [showPassword]="showPassword"
        [nextDisabled]="nextDisabled"
        (showPasswordChange)="showPassword = $event"
        (proximo)="nextStep()">
      </app-etapa-cadastro-email>
    </mdb-step>
    <mdb-step name="Validar Email" [editable]="true" [stepForm]="formToken">
      <app-etapa-cadastro-email
        etapa="email"
        [typeForm]="typeForm"
        [formToken]="formToken"
        [disableButton]="disableButton"
        (voltarToken)="resetStep()"
        (continuarToken)="nextStepEmail()"
        (reenviarToken)="resendToken()">
      </app-etapa-cadastro-email>
    </mdb-step>
    <mdb-step name="Dados do Credor Pessoa Jurídica" [editable]="true" [stepForm]="formEmpresa" (click)="stepper.previous()">
      <app-dados-credor
        [formEmpresa]="formEmpresa"
        (adicionarEmpresa)="addEmpresa()"
        (removerEmpresa)="removeEmpresa($event)"
        (voltar)="resetStep()"
        (efetuarCadastro)="cadastrarEmpresas()">
      </app-dados-credor>
    </mdb-step>
  </mdb-stepper>
</div>

<!-- //Formulario Tipo Entidade  -->
<div *ngIf="typeForm == 'ENTIDADE'" class="col-11 col-lg-10 col-sm-12 col-md-12 box-form p-5  mt-3">
  <div class="row">
    <span data-testid="botao-voltar" class="back-button" (click)="backStep()">
      <i class="fas fa-angle-left"></i> voltar
    </span>
  </div>
  <mdb-stepper [linear]="true" #stepperEntidade class="col-12">
    <mdb-step name="Dados Responsavel" [stepForm]="formResponsavelEntidade">
      <app-etapa-cadastro-email
        etapa="dados"
        [typeForm]="typeForm"
        [formResponsavelEntidade]="formResponsavelEntidade"
        [showPassword]="showPassword"
        [nextDisabled]="nextDisabled"
        (showPasswordChange)="showPassword = $event"
        (proximo)="nextStep()">
      </app-etapa-cadastro-email>
    </mdb-step>
    <mdb-step name="Validar Email" [editable]="true" [stepForm]="formToken">
      <app-etapa-cadastro-email
        etapa="email"
        [typeForm]="typeForm"
        [formToken]="formToken"
        [disableButton]="disableButton"
        (voltarToken)="resetStep()"
        (continuarToken)="nextStepEmail()"
        (reenviarToken)="resendToken()">
      </app-etapa-cadastro-email>
    </mdb-step>
    <mdb-step name="Dados Entidade" [editable]="true" [stepForm]="formEntity" (click)="stepperEntidade.previous()">
      <app-formulario-entidade
        [formEntity]="formEntity"
        [tableDdi]="tableDdi"
        [nextDisabled]="nextDisabled"
        (efetuarCadastro)="cadastrarEntidade()">
      </app-formulario-entidade>
    </mdb-step>
  </mdb-stepper>
</div>
